import React, { useContext, useState } from 'react';
import { useInterface } from '../../context/InterfaceProvider';
import { AuthContext } from '../../context/AuthProvider';

function readFavorites(key) {
  try {
    const stored = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(stored) ? stored.map(String) : [];
  } catch { return []; }
}

function TitleActions({ card, username }) {
  const storageKey = `at_simple_favorites:${encodeURIComponent(username || 'guest')}`;
  const cardId = String(card.card_id);
  const [favorite, setFavorite] = useState(() => readFavorites(storageKey).includes(cardId));
  const [status, setStatus] = useState('');
  const [showLink, setShowLink] = useState(false);
  const toggleFavorite = () => {
    const next = !favorite;
    const saved = readFavorites(storageKey).filter(id => id !== cardId);
    if (next) saved.push(cardId);
    setFavorite(next);
    try {
      localStorage.setItem(storageKey, JSON.stringify(saved));
      setStatus(next ? 'Favorited on this browser.' : 'Favorite removed.');
    } catch { setStatus('Favorite changed for this visit; browser storage is unavailable.'); }
  };
  const share = async () => {
    const url = window.location.href;
    try {
      if (navigator.share) {
        await navigator.share({ title: `${card.card_pokemon || ''} ${card.card || ''}`.trim(), url });
        return;
      }
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        setStatus('Card link copied.');
        return;
      }
    } catch (error) { if (error.name === 'AbortError') return; }
    setShowLink(true);
    setStatus('Copy this link to share the card.');
  };
  return <>
    <div className="simple-title-actions">
      <button type="button" aria-label="Favorite on this browser" aria-pressed={favorite} onClick={toggleFavorite} title="Favorite on this browser">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21S2 15 2 8a5.5 5.5 0 0 1 10-3 5.5 5.5 0 0 1 10 3c0 7-10 13-10 13Z" fill={favorite ? '#ff628f' : 'none'} stroke="#ff83ad" strokeWidth="1.6" /></svg>
      </button>
      <button type="button" aria-label="Share card" onClick={share}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true" focusable="false"><path d="m7 11 10-6M7 13l10 6" /><circle cx="5" cy="12" r="3" /><circle cx="19" cy="4" r="3" /><circle cx="19" cy="20" r="3" /></svg>
      </button>
    </div>
    <span className="simple-title-status" role="status">{status}</span>
    {showLink && <label className="simple-share-link">Card link<input readOnly value={window.location.href} onFocus={event => event.target.select()} /></label>}
  </>;
}

export default function SimpleCardTitle({ card }) {
  const { version } = useInterface();
  const { user } = useContext(AuthContext) || {};
  const set = <div className="card-set">{card.card_set_year} {card.card_game} {card.card_set}</div>;
  const title = <div className="card-title">{card.card_pokemon} {card.card}</div>;
  if (version !== 'simple') return <>{set}{title}</>;
  return <section className="simple-card-title-panel simple-neon-panel" aria-label="Card title">
    <div className="simple-title-copy">{set}{title}</div>
    <TitleActions key={`${user?.username}:${card.card_id}`} card={card} username={user?.username} />
    <div className="simple-card-metadata" aria-label="Card metadata">
      {card.card_number && <span>#{card.card_number}</span>}
      {card.card_set && <span>{card.card_set}</span>}
      {card.card_language && <span>{card.card_language}</span>}
    </div>
  </section>;
}
